// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.league-tournament-report__container {
    padding: calc( var( --space-and-half ) + var(--space-quarter) ) 0;        
}

.league-tournament-report__event-container .league-tournament-report__title-nav {
    margin-bottom: var(--space-x2);
}

.league-tournament-report__container .MuiTabs-root {
    margin-bottom: var(--space-half-quarter);
    background-color: var(--white-color);
}

.league-tournament-report__container__card{
    /* background: var(--white-color); */
    position: relative;
}

.league-tournament-report__title-nav {
    display: flex;
    align-items: center;
    margin-bottom: var(--space-and-half);
    
}

.league-tournament-report__title-nav span {
    color: #000000;
    font-size: 1.5rem;
    margin-right: var( --space-x2 );
    cursor: pointer;
}

.league-tournament-report__podium{}

.league-tournament-report__podium__title{
    margin-top: var(--space);
    margin-bottom: var(--space-x2);
}
.league-tournament-report__recognition__title__color.baloa-subtitle-1{
    color: var(--basic-gray-color);
}
.league-tournament-report__recognition{}

.league-tournament-report__recognition__title{
    margin-top: calc(var(--space-x3) + var(--space-half));
    margin-bottom: var(--space-x2);
    text-align: center;
}
.league-tournament-report__podium__title__color{
    color: var(--primary-very-dark-color);
}

.league-tournament-report__tab {
    border-radius: 0 0 var(--space-half) var(--space-half);
    border-left: var(--space-half-quarter) solid var(--white-color);
    border-right: var(--space-half-quarter) solid var(--white-color);
    border-bottom: var(--space-half-quarter) solid var(--white-color);
    background: var(--white-color);
}

.league-tournament-report__tab .container-position-goal-scorer-table {
    display: block;
}

.league-tournament-report__tab .container-position-goal-scorer-table .col-left {
    width: 100%;
}

.league-tournament-report__tab .container-position-goal-scorer-table .col-right {
    width: 100%;
    padding-left: 0;
}

.league__tournament__report-msg-container p {
    width: 100%;
    text-align: center;
    display: block;
}

.league__tournament__report-msg-container p:first-child {
    margin-bottom: var( --space );
    margin-top: var( --space-x3 );
}

.league-tournament-report__container button {
    min-width: 100px !important;
}


.league__tournament__tournament-podium .podium-content {
    display: block;
}

.league__tournament__tournament-podium .podium-content .podium-content__recognition {
    margin-top: var(--space-x3);
}


.league-tournament-report__image {
    border-radius: 16px 16px 0px 0px;
    background: rgba(77, 84, 81, 0.64);
    backdrop-filter: blur(4px);  
    display: flex;
    align-items: center;
    justify-content: center;    
}

.league-tournament-report__basic-info__tabs .MuiTab-wrapper{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + 1px);
    line-height: calc(var(--space) + var(--space-quarter));
    letter-spacing: 0.005em;
    color: var(--primary-dark-color);
    text-transform: none;
}

.league-tournament-report__dates__btns .MuiTabScrollButton-root svg {
    font-size: calc( var( --space ) + var( --space-quarter ) );
    
}

.league-tournament-report__dates__btns .MuiTabScrollButton-root.Mui-disabled {
    opacity: 0.8;
    color: var(--disabled-color)
}


.league-tournament-report__dates__btns .MuiTabs-flexContainer {
    border-bottom: none;
}

.league__tournament__report__tournament-teams {
    list-style-type: none;
}

.league__tournament__report__tournament-teams li {
    display: flex;
}

.league__tournament__report__tournament-teams .icon-team {
    font-size: var(--space-x2);
    color: var(--secondary-light-color);
}

.league__tournament__report__tournament-teams .icon-chevron {
    color: var(--secondary-light-color);
}

.league-tournament-report__event-container__tournament-info .post__content__tournament-result__info-date {
    
    padding: var(--space-half) 0;
    
}

.league-tournament-report__event-container__tournament-info .post__content__tournament-result__info-date .post__content__tournament-result__info-date__col {
    margin: calc( var(--space) - var(--space-quarter)) 0;
}

.league-tournament-report__event-container__tournament-info {
    background-color: var(--white-color);
    padding: var(--space-and-half) var(--space);
    border-radius: var(--space-quarter);
    box-shadow: var(--shadow-card-2);

}

.league__tournament__no-dates-phases__container {
    text-align: center;
    margin-top: var(--space-x3);
    
}

.league__tournament__no-dates-phases__container p {
    width: 100%;
    text-align: center;
    display: block;
    margin-top: var(--space);
}

.league-tournament-report__event-container .match-result__center__header {
    display: none;
}

.league-tournament-report__event-container .container-match-report {
    margin: 0;
}

.league-tournament-report__container__card__separator{
    border-top: 1px solid var(--separator-color);
}

.league-tournament-report__image .icon-trophy{
    color: var(--white-color);
    font-size: 52px;
    width: 419px;
    height: 229px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.league-tournament-report__image img{
    width: 419px;
    height: 229px;
}
.league-tournament-report__image__tags{
    position: absolute;
    display: flex;
    bottom: 8px;
    left: 8px;
}
.league-tournament-report__image__tags-tag{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var(--white-color);
    background: rgba(0, 0, 0, 0.61);
    border-radius: 32px;
    padding: 5px 8px;
}

.league-tournament-report__image__tags-tag:first-of-type {
    margin-right: var(--space-quarter);
}

.league-tournament-report__image__tags-tag:last-of-type {
    margin-left: var(--space-quarter);
}

.league-tournament-report__tournament-name__container {
    display: flex;
    align-items: center;
    padding: 24px 32px;
    background-color: var(--white-color);
}

.league-tournament-report__tournament-name.baloa-headline-2 {
    color: var(--primary-very-dark-color);
    margin-left: var(--space-half);
}

.league-tournament-report__tournament-name__container img {
    width: 42px;
    height: 42px;
    border-radius: 50%;
}

.league-tournament-report__tournament-name__container .icon-ball{
    color: var(--white-color);
    font-size: 29px;
    padding: 5px;
    border-radius: 50%;
}

.league-tournament-report__classified-square {
    width: 16px;
    height: 16px;
    border-radius: 2px;
    background-color: var(--new-green-color);
    margin-right: var(--space-half-quarter);
}

.league-tournament-report__best-third-square {
    width: 16px;
    height: 16px;
    border-radius: 2px;
    background-color: #FA7B17;
    margin-right: var(--space-half-quarter);
}

.league-tournament-report__classified {
    display: flex;
    align-items: center;
    padding-bottom: 16px; 
    padding-left: var(--space-half);       
}

.league-tournament-report__classified:first-of-type {
    margin-top: var(--space-half);      
}

.league-tournament-report__phases__list {
    background-color: var(--white-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.league-tournament-report__phases__list button{
    margin-right: 16px;
}

.table-list{
    display: block;
}

.league-tournament-report__phases__list .MuiInputBase-root {
    font-family: var(--secondary-font);
    font-weight: var(--font-medium);
    font-size: 19px;
    line-height: 22px;
}

.league-tournament-report__phases__list .MuiFormControl-root {
    min-width: 350px;
    margin: 16px 16px 24px 16px;
    border: 1px solid var(--new-gray-color);
    padding: var(--space-half-quarter);
    border-radius: var(--space-quarter);
}

.league-tournament-report__phases__list.table-list .MuiFormControl-root {
    margin-left: var(--space-quarter);
}

.league-tournament-report__image__background-img_container {
    position: absolute;
    width: 100%;
    height: 229px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 16px 16px 0px 0px;
}

.league-tournament-report__image__background-img {
    width: 100%;
}

.league-tournament-report__phases__list .MuiInput-underline:before,
.league-tournament-report__phases__list .MuiInput-underline:hover:not(.Mui-disabled):before {
    border-bottom: none;
}

.league-tournament-report__podium__container {
    background-color: var(--white-color);
    padding-top: 100px;
    padding-bottom: var(--space-x2);
}

.league-tournament-report_phases_list_options{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
}

.tournament-edit-tournament_position_table_opcions{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}

.tournament-edit-tournament_iframe_share-btn.small {
    display: flex;
    align-items: center;
    padding: var(--space-half-quarter);
    text-wrap-mode: nowrap;
    margin-bottom: 12px;
}

.tournament-edit-tournament_iframe_share-btn.small:hover .baloa-table {
    color: var(--white-color);
}

.tournament-edit-tournament_iframe_share-btn .hubicon-code {
    margin-right: var(--space-half-quarter);
    font-size: var(--space-and-half);
}

.tournament-edit-tournament_iframe_share-btn .baloa-table {
    font-weight: var(--font-medium);
    color: var(--new-green-color);
}

.tournament-edit-tournament_iframe_share-btn.small:focus .baloa-table {
    color: var(--white-color);
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .league-tournament-report__image img {
        width: 100%;
        height: unset;
    }

    .league-tournament-report__tournament-name__container{
        padding: var(--space);
    }

    .league-tournament-report__phases__list{
        /* border-bottom: 1px solid var( --new-gray-background-color ); */
        padding: var(--space);
    }

    .league-tournament-report__phases__list .MuiFormControl-root {
        border-radius: var(--space-half);
        margin: 0;
        min-width: unset;
        width: 100%;
        padding: 0 var(--space-half-quarter);
    }

    .league-tournament-report__phases__list .MuiInputBase-root {
        font-size: var(--space);
    }

    .league-tournament-report-dates__group-title.baloa-normal-medium{
        margin: 0 var(--space) calc( var(--space) + 2px ) var(--space);
        border-radius: 5px;
        
    }

    .league-tournament-report-dates__teams-names-container {
        width: 100%;
        padding: var(--space);
    }

    .league-tournament-report-dates__match-detail-container{
        width: 100%;
    }

    .league-tournament-report-dates__teams-result-container{
        border-left: 0;
    }

    .league-tournament-report-dates__teams-container .baloa-normal{
        font-size: calc( var(--space) + 2px );
        color: var(--primary-very-dark-color);
    }

    .league-tournament-report-dates__teams-container .baloa-normal-medium {
        font-size: calc( var(--space) + 2px );
        color: var(--primary-very-dark-color);
    }

    .league-tournament-report__tab {
        border-left: 0;
        border-right: 0;
        border-bottom: 0;
        background: transparent;
    }

    th.baloa-table {
        font-weight: var(--font-medium);
        color: var(--basic-gray-color);
        font-size: var(--space);
    }

    td.baloa-table {
        color: var(--primary-very-dark-color);
    }
    .league-tournament-report__classified.classified {
        padding-top: calc( var(--space) + var(--space-quarter) + 1px );
    }

    .league-tournament-report__title-nav {        
        margin-left: calc( var(--space) + var(--space-quarter) + 1px );;        
    }
    .league-tournament-report__tournament-name.baloa-headline-2 {
        font-size: calc( var(--space) + var(--space-quarter) );
    }
    .league-tournament-report__tournament-name__container img {
        width: 28px;
        height: 28px;
    }
    .league-tournament-report__image__tags-tag{
        font-size: 10px;
    }
    .league-tournament-report__image__background-img_container {
        display: none;
    }
    .league-tournament-report__recognition__title {
        margin-top: 0;
        margin-left: var(--space-and-half);
        text-align: left;
    }
    .league-tournament-report__recognition {
        margin-top: var(--space-x2);
    }
    .league-tournament-report__container__card{
        height: 100vh;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/league-tournament-report-component/LeagueTournamentReportComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,iEAAiE;AACrE;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oCAAoC;;AAExC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,+BAA+B;IAC/B,eAAe;AACnB;;AAEA,kCAAkC;;AAElC;IACI,wBAAwB;IACxB,8BAA8B;AAClC;AACA;IACI,8BAA8B;AAClC;AACA,uCAAuC;;AAEvC;IACI,qDAAqD;IACrD,8BAA8B;IAC9B,kBAAkB;AACtB;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,sDAAsD;IACtD,+DAA+D;IAC/D,gEAAgE;IAChE,iEAAiE;IACjE,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,mCAAmC;IACnC,sDAAsD;IACtD,uBAAuB;IACvB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,0DAA0D;;AAE9D;;AAEA;IACI,YAAY;IACZ;AACJ;;;AAGA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;;IAEI,4BAA4B;;AAEhC;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,oCAAoC;IACpC,2CAA2C;IAC3C,mCAAmC;IACnC,gCAAgC;;AAEpC;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;;AAE/B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,SAAS;AACb;AACA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,uCAAuC;AAC3C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,uCAAuC;IACvC,kCAAkC;IAClC,mCAAmC;AACvC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,iEAAiE;QACjE,qBAAqB;IACzB;;IAEA;QACI,gCAAgC;QAChC,SAAS;QACT,gBAAgB;QAChB,WAAW;QACX,oCAAoC;IACxC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,8DAA8D;QAC9D,kBAAkB;;IAEtB;;IAEA;QACI,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,qCAAqC;QACrC,qCAAqC;IACzC;;IAEA;QACI,qCAAqC;QACrC,qCAAqC;IACzC;;IAEA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;QAChB,uBAAuB;IAC3B;;IAEA;QACI,+BAA+B;QAC/B,8BAA8B;QAC9B,uBAAuB;IAC3B;;IAEA;QACI,qCAAqC;IACzC;IACA;QACI,8DAA8D;IAClE;;IAEA;QACI,8DAA8D;IAClE;IACA;QACI,sDAAsD;IAC1D;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,kCAAkC;QAClC,gBAAgB;IACpB;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".league-tournament-report__container {\n    padding: calc( var( --space-and-half ) + var(--space-quarter) ) 0;        \n}\n\n.league-tournament-report__event-container .league-tournament-report__title-nav {\n    margin-bottom: var(--space-x2);\n}\n\n.league-tournament-report__container .MuiTabs-root {\n    margin-bottom: var(--space-half-quarter);\n    background-color: var(--white-color);\n}\n\n.league-tournament-report__container__card{\n    /* background: var(--white-color); */\n    position: relative;\n}\n\n.league-tournament-report__title-nav {\n    display: flex;\n    align-items: center;\n    margin-bottom: var(--space-and-half);\n    \n}\n\n.league-tournament-report__title-nav span {\n    color: #000000;\n    font-size: 1.5rem;\n    margin-right: var( --space-x2 );\n    cursor: pointer;\n}\n\n.league-tournament-report__podium{}\n\n.league-tournament-report__podium__title{\n    margin-top: var(--space);\n    margin-bottom: var(--space-x2);\n}\n.league-tournament-report__recognition__title__color.baloa-subtitle-1{\n    color: var(--basic-gray-color);\n}\n.league-tournament-report__recognition{}\n\n.league-tournament-report__recognition__title{\n    margin-top: calc(var(--space-x3) + var(--space-half));\n    margin-bottom: var(--space-x2);\n    text-align: center;\n}\n.league-tournament-report__podium__title__color{\n    color: var(--primary-very-dark-color);\n}\n\n.league-tournament-report__tab {\n    border-radius: 0 0 var(--space-half) var(--space-half);\n    border-left: var(--space-half-quarter) solid var(--white-color);\n    border-right: var(--space-half-quarter) solid var(--white-color);\n    border-bottom: var(--space-half-quarter) solid var(--white-color);\n    background: var(--white-color);\n}\n\n.league-tournament-report__tab .container-position-goal-scorer-table {\n    display: block;\n}\n\n.league-tournament-report__tab .container-position-goal-scorer-table .col-left {\n    width: 100%;\n}\n\n.league-tournament-report__tab .container-position-goal-scorer-table .col-right {\n    width: 100%;\n    padding-left: 0;\n}\n\n.league__tournament__report-msg-container p {\n    width: 100%;\n    text-align: center;\n    display: block;\n}\n\n.league__tournament__report-msg-container p:first-child {\n    margin-bottom: var( --space );\n    margin-top: var( --space-x3 );\n}\n\n.league-tournament-report__container button {\n    min-width: 100px !important;\n}\n\n\n.league__tournament__tournament-podium .podium-content {\n    display: block;\n}\n\n.league__tournament__tournament-podium .podium-content .podium-content__recognition {\n    margin-top: var(--space-x3);\n}\n\n\n.league-tournament-report__image {\n    border-radius: 16px 16px 0px 0px;\n    background: rgba(77, 84, 81, 0.64);\n    backdrop-filter: blur(4px);  \n    display: flex;\n    align-items: center;\n    justify-content: center;    \n}\n\n.league-tournament-report__basic-info__tabs .MuiTab-wrapper{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + 1px);\n    line-height: calc(var(--space) + var(--space-quarter));\n    letter-spacing: 0.005em;\n    color: var(--primary-dark-color);\n    text-transform: none;\n}\n\n.league-tournament-report__dates__btns .MuiTabScrollButton-root svg {\n    font-size: calc( var( --space ) + var( --space-quarter ) );\n    \n}\n\n.league-tournament-report__dates__btns .MuiTabScrollButton-root.Mui-disabled {\n    opacity: 0.8;\n    color: var(--disabled-color)\n}\n\n\n.league-tournament-report__dates__btns .MuiTabs-flexContainer {\n    border-bottom: none;\n}\n\n.league__tournament__report__tournament-teams {\n    list-style-type: none;\n}\n\n.league__tournament__report__tournament-teams li {\n    display: flex;\n}\n\n.league__tournament__report__tournament-teams .icon-team {\n    font-size: var(--space-x2);\n    color: var(--secondary-light-color);\n}\n\n.league__tournament__report__tournament-teams .icon-chevron {\n    color: var(--secondary-light-color);\n}\n\n.league-tournament-report__event-container__tournament-info .post__content__tournament-result__info-date {\n    \n    padding: var(--space-half) 0;\n    \n}\n\n.league-tournament-report__event-container__tournament-info .post__content__tournament-result__info-date .post__content__tournament-result__info-date__col {\n    margin: calc( var(--space) - var(--space-quarter)) 0;\n}\n\n.league-tournament-report__event-container__tournament-info {\n    background-color: var(--white-color);\n    padding: var(--space-and-half) var(--space);\n    border-radius: var(--space-quarter);\n    box-shadow: var(--shadow-card-2);\n\n}\n\n.league__tournament__no-dates-phases__container {\n    text-align: center;\n    margin-top: var(--space-x3);\n    \n}\n\n.league__tournament__no-dates-phases__container p {\n    width: 100%;\n    text-align: center;\n    display: block;\n    margin-top: var(--space);\n}\n\n.league-tournament-report__event-container .match-result__center__header {\n    display: none;\n}\n\n.league-tournament-report__event-container .container-match-report {\n    margin: 0;\n}\n\n.league-tournament-report__container__card__separator{\n    border-top: 1px solid var(--separator-color);\n}\n\n.league-tournament-report__image .icon-trophy{\n    color: var(--white-color);\n    font-size: 52px;\n    width: 419px;\n    height: 229px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.league-tournament-report__image img{\n    width: 419px;\n    height: 229px;\n}\n.league-tournament-report__image__tags{\n    position: absolute;\n    display: flex;\n    bottom: 8px;\n    left: 8px;\n}\n.league-tournament-report__image__tags-tag{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: normal;\n    font-size: 14px;\n    line-height: 17px;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var(--white-color);\n    background: rgba(0, 0, 0, 0.61);\n    border-radius: 32px;\n    padding: 5px 8px;\n}\n\n.league-tournament-report__image__tags-tag:first-of-type {\n    margin-right: var(--space-quarter);\n}\n\n.league-tournament-report__image__tags-tag:last-of-type {\n    margin-left: var(--space-quarter);\n}\n\n.league-tournament-report__tournament-name__container {\n    display: flex;\n    align-items: center;\n    padding: 24px 32px;\n    background-color: var(--white-color);\n}\n\n.league-tournament-report__tournament-name.baloa-headline-2 {\n    color: var(--primary-very-dark-color);\n    margin-left: var(--space-half);\n}\n\n.league-tournament-report__tournament-name__container img {\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n}\n\n.league-tournament-report__tournament-name__container .icon-ball{\n    color: var(--white-color);\n    font-size: 29px;\n    padding: 5px;\n    border-radius: 50%;\n}\n\n.league-tournament-report__classified-square {\n    width: 16px;\n    height: 16px;\n    border-radius: 2px;\n    background-color: var(--new-green-color);\n    margin-right: var(--space-half-quarter);\n}\n\n.league-tournament-report__best-third-square {\n    width: 16px;\n    height: 16px;\n    border-radius: 2px;\n    background-color: #FA7B17;\n    margin-right: var(--space-half-quarter);\n}\n\n.league-tournament-report__classified {\n    display: flex;\n    align-items: center;\n    padding-bottom: 16px; \n    padding-left: var(--space-half);       \n}\n\n.league-tournament-report__classified:first-of-type {\n    margin-top: var(--space-half);      \n}\n\n.league-tournament-report__phases__list {\n    background-color: var(--white-color);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.league-tournament-report__phases__list button{\n    margin-right: 16px;\n}\n\n.table-list{\n    display: block;\n}\n\n.league-tournament-report__phases__list .MuiInputBase-root {\n    font-family: var(--secondary-font);\n    font-weight: var(--font-medium);\n    font-size: 19px;\n    line-height: 22px;\n}\n\n.league-tournament-report__phases__list .MuiFormControl-root {\n    min-width: 350px;\n    margin: 16px 16px 24px 16px;\n    border: 1px solid var(--new-gray-color);\n    padding: var(--space-half-quarter);\n    border-radius: var(--space-quarter);\n}\n\n.league-tournament-report__phases__list.table-list .MuiFormControl-root {\n    margin-left: var(--space-quarter);\n}\n\n.league-tournament-report__image__background-img_container {\n    position: absolute;\n    width: 100%;\n    height: 229px;\n    overflow: hidden;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 16px 16px 0px 0px;\n}\n\n.league-tournament-report__image__background-img {\n    width: 100%;\n}\n\n.league-tournament-report__phases__list .MuiInput-underline:before,\n.league-tournament-report__phases__list .MuiInput-underline:hover:not(.Mui-disabled):before {\n    border-bottom: none;\n}\n\n.league-tournament-report__podium__container {\n    background-color: var(--white-color);\n    padding-top: 100px;\n    padding-bottom: var(--space-x2);\n}\n\n.league-tournament-report_phases_list_options{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: white;\n}\n\n.tournament-edit-tournament_position_table_opcions{\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n}\n\n.tournament-edit-tournament_iframe_share-btn.small {\n    display: flex;\n    align-items: center;\n    padding: var(--space-half-quarter);\n    text-wrap-mode: nowrap;\n    margin-bottom: 12px;\n}\n\n.tournament-edit-tournament_iframe_share-btn.small:hover .baloa-table {\n    color: var(--white-color);\n}\n\n.tournament-edit-tournament_iframe_share-btn .hubicon-code {\n    margin-right: var(--space-half-quarter);\n    font-size: var(--space-and-half);\n}\n\n.tournament-edit-tournament_iframe_share-btn .baloa-table {\n    font-weight: var(--font-medium);\n    color: var(--new-green-color);\n}\n\n.tournament-edit-tournament_iframe_share-btn.small:focus .baloa-table {\n    color: var(--white-color);\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .league-tournament-report__image img {\n        width: 100%;\n        height: unset;\n    }\n\n    .league-tournament-report__tournament-name__container{\n        padding: var(--space);\n    }\n\n    .league-tournament-report__phases__list{\n        /* border-bottom: 1px solid var( --new-gray-background-color ); */\n        padding: var(--space);\n    }\n\n    .league-tournament-report__phases__list .MuiFormControl-root {\n        border-radius: var(--space-half);\n        margin: 0;\n        min-width: unset;\n        width: 100%;\n        padding: 0 var(--space-half-quarter);\n    }\n\n    .league-tournament-report__phases__list .MuiInputBase-root {\n        font-size: var(--space);\n    }\n\n    .league-tournament-report-dates__group-title.baloa-normal-medium{\n        margin: 0 var(--space) calc( var(--space) + 2px ) var(--space);\n        border-radius: 5px;\n        \n    }\n\n    .league-tournament-report-dates__teams-names-container {\n        width: 100%;\n        padding: var(--space);\n    }\n\n    .league-tournament-report-dates__match-detail-container{\n        width: 100%;\n    }\n\n    .league-tournament-report-dates__teams-result-container{\n        border-left: 0;\n    }\n\n    .league-tournament-report-dates__teams-container .baloa-normal{\n        font-size: calc( var(--space) + 2px );\n        color: var(--primary-very-dark-color);\n    }\n\n    .league-tournament-report-dates__teams-container .baloa-normal-medium {\n        font-size: calc( var(--space) + 2px );\n        color: var(--primary-very-dark-color);\n    }\n\n    .league-tournament-report__tab {\n        border-left: 0;\n        border-right: 0;\n        border-bottom: 0;\n        background: transparent;\n    }\n\n    th.baloa-table {\n        font-weight: var(--font-medium);\n        color: var(--basic-gray-color);\n        font-size: var(--space);\n    }\n\n    td.baloa-table {\n        color: var(--primary-very-dark-color);\n    }\n    .league-tournament-report__classified.classified {\n        padding-top: calc( var(--space) + var(--space-quarter) + 1px );\n    }\n\n    .league-tournament-report__title-nav {        \n        margin-left: calc( var(--space) + var(--space-quarter) + 1px );;        \n    }\n    .league-tournament-report__tournament-name.baloa-headline-2 {\n        font-size: calc( var(--space) + var(--space-quarter) );\n    }\n    .league-tournament-report__tournament-name__container img {\n        width: 28px;\n        height: 28px;\n    }\n    .league-tournament-report__image__tags-tag{\n        font-size: 10px;\n    }\n    .league-tournament-report__image__background-img_container {\n        display: none;\n    }\n    .league-tournament-report__recognition__title {\n        margin-top: 0;\n        margin-left: var(--space-and-half);\n        text-align: left;\n    }\n    .league-tournament-report__recognition {\n        margin-top: var(--space-x2);\n    }\n    .league-tournament-report__container__card{\n        height: 100vh;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
